// extracted by mini-css-extract-plugin
export default {"bannerContainer":"AboutBanner_bannerContainer__4GVQe","main_title":"AboutBanner_main_title__sTVmd","main_subtitle":"AboutBanner_main_subtitle__GBw1L"};